import solutionDlg from './src/main.js'
export default solutionDlg



// WEBPACK FOOTER //
// ./src/components/solutionDlg/index.js